import {
  Component,
  Input,
  Output,
  EventEmitter,
  output,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublishedSimulationsTableComponent } from '../../../components/published-simulations-table/published-simulations-table.component';
import { AllSimulationsTableComponent } from '../../../components/all-simulations-table/all-simulations-table.component';
import { SelfServeLocalStorageUtil } from 'src/app/utils/local-storage.util';

@Component({
  selector: 'app-assignment-simulations',
  standalone: true,
  templateUrl: './simulations.component.html',
  styleUrls: ['./simulations.component.scss'],
  imports: [
    CommonModule,
    PublishedSimulationsTableComponent,
    AllSimulationsTableComponent,
  ],
})
export class AssignmentSimulationsComponent implements OnInit, OnChanges {
  @Input() selectedAccount: { label: string; value: string } | undefined;
  @Input() selectedAccountUuid: string = '';
  @Input() refreshKey: number = 0;

  selectedAccountHasAuthor: boolean = false;
  selectedAccountHasAssignmentManager: boolean = false;

  @Output() deleteSimulation = new EventEmitter<any>();
  @Output() duplicateSimulation = new EventEmitter<any>();
  @Output() archiveSimulation = new EventEmitter<any>();
  openGenerationModal = output<any>();

  constructor() {}

  ngOnInit() {
    this.determineSelectedAccountRoles();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedAccountUuid']) {
      this.determineSelectedAccountRoles();
    }
  }

  private determineSelectedAccountRoles(): void {
    if (!this.selectedAccountUuid) {
      this.selectedAccountHasAuthor = false;
      this.selectedAccountHasAssignmentManager = false;
      return;
    }

    const accountRoles = SelfServeLocalStorageUtil.getSelectedAccountRoles(
      this.selectedAccountUuid
    );
    this.selectedAccountHasAuthor = accountRoles.hasAuthor;
    this.selectedAccountHasAssignmentManager =
      accountRoles.hasAssignmentManager;
  }

  shouldShowAllSimulationsTable(): boolean {
    return this.selectedAccountHasAuthor;
  }

  shouldShowPublishedSimulationsTable(): boolean {
    return (
      this.selectedAccountHasAssignmentManager && !this.selectedAccountHasAuthor
    );
  }

  onDeleteSimulation(event: any) {
    this.deleteSimulation.emit(event);
  }

  onDuplicateSimulation(event: any) {
    this.duplicateSimulation.emit(event);
  }

  onArchiveSimulation(event: any) {
    this.archiveSimulation.emit(event);
  }

  onOpenGenerationModal(event: any) {
    this.openGenerationModal.emit(event);
  }
}
